export default __webpack_public_path__ + "static/media/basket.c167cc3c.svg";